module.exports = __webpack_public_path__ + "img/verizon.88fb8c0f.svg";